
import { Helmet } from 'react-helmet';
import FooterSection from '@/components/FooterSection';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - The Liberated Consultant by Rey Marques</title>
        <meta name="description" content="Terms of Service for The Liberated Consultant by Rey Marques." />
      </Helmet>
      
      <div className="min-h-screen bg-book-lightBg">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
            <h1 className="text-3xl md:text-4xl font-bold mb-8 text-book-darkBlue">Terms of Service</h1>
            
            <div className="prose max-w-none">
              <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">1. Acceptance of Terms</h2>
              <p>By accessing or using our website, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">2. Use License</h2>
              <p>Permission is granted to temporarily access the materials on our website for personal, non-commercial use only.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">3. Disclaimer</h2>
              <p>The materials on our website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">4. Limitations</h2>
              <p>In no event shall we or our suppliers be liable for any damages arising out of the use or inability to use the materials on our website.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">5. Governing Law</h2>
              <p>These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    </>
  );
};

export default Terms;
